var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditThick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4949 3.23779H3.10998C2.55038 3.23779 2.0137 3.46009 1.618 3.85579C1.2223 4.25149 1 4.78817 1 5.34778V20.1177C1 20.6773 1.2223 21.2139 1.618 21.6096C2.0137 22.0053 2.55038 22.2276 3.10998 22.2276H17.8799C18.4395 22.2276 18.9761 22.0053 19.3718 21.6096C19.7675 21.2139 19.9898 20.6773 19.9898 20.1177V12.7327",
    stroke: "#425364",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4075 1.65549C18.8272 1.23579 19.3964 1 19.99 1C20.5835 1 21.1528 1.23579 21.5725 1.65549C21.9922 2.07519 22.228 2.64443 22.228 3.23797C22.228 3.83152 21.9922 4.40076 21.5725 4.82046L11.55 14.8429L7.33008 15.8979L8.38507 11.6779L18.4075 1.65549Z",
    stroke: "#425364",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditThick);
export default __webpack_public_path__ + "static/media/EditThick.c8fc5f6ee02d8988c1094225d8350225.svg";
export { ForwardRef as ReactComponent };